import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { addMonths } from "date-fns";
import { commonAdapters } from "src/common-adapters";
import type { ExternalProviderDashboardVM } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import { useInvoiceSubmit } from "../../hooks/use-invoice-submit";
import { InvoiceSection } from "./invoice-section.content";
import { createInvoiceFormSchema, formatInvoiceDataToFormData, type InvoiceFormInputs } from "../../form-validation/invoice-form.schema";

interface Props {
  data: ExternalProviderDashboardVM;
}

export const InvoiceSectionContainer = ({ data }: Props) => {
  const { dateProvider } = commonAdapters;
  const now = useMemo(() => dateProvider!.now(), [dateProvider]);
  const form = useForm<InvoiceFormInputs>({
    resolver: yupResolver(createInvoiceFormSchema(now)),
    defaultValues: { ...formatInvoiceDataToFormData(data), invoiceDate: now, invoiceDeadline: addMonths(now, 1) },
  });
  const { submitInvoice, uploadInvoice, uploadProcessing, submitProcessing } = useInvoiceSubmit(form, data.participation?.id ?? null);

  return (
    <InvoiceSection
      data={data}
      now={now}
      form={form}
      onSubmit={form.handleSubmit(submitInvoice)}
      onUpload={uploadInvoice}
      uploadProcessing={uploadProcessing}
      submitProcessing={submitProcessing}
    />
  );
};
